<div class="modal-header bg-dark text-white">
    <h3 class="modal-title" id="modal-basic-title">Add New Supplier</h3>
    <div class="ms-auto" data-bs-theme="dark">
      <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>
</div>
<div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="submitSupplier()" novalidate>
      <div class="row mb-3">
          <div class="form-group col-12 col-md-6">
              <label>{{ legal.name }}
                  <i class="fas fa-info-circle text-muted ms-1" placement="top" data-testid="supplier-company-tip"
                     [ngbTooltip]="legal.nameTipOther" [attr.aria-label]="legal.nameTipOther"></i>
              </label>
              <input class="form-control" data-testid="supplier-company" formControlName="name"
                [ngClass]="getFormGroupErrorClasses(form.controls.name)"
                [placeholder]="legal.name">
              <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.name)">
                <p *ngIf="form.controls.name.errors.required">{{ legal.nameRequired }}</p>
              </div>
              <small class="form-text text-muted"></small>
            </div>
            <div class="form-group col-12 col-md-6">
              <label>Alias (Optional)</label>
              <input class="form-control" formControlName="supplier_alias"
                placeholder="Custom alias for this supplier">
              <small class="form-text text-muted">Your custom name for this supplier (only visible to you)</small>
            </div>
            <div formGroupName="contact" class="form-group col-12 col-md-6" [ngClass]="getFormGroupErrorClasses(contact.controls.last_name)">
                <label>Last Name</label>
                <input class="form-control" data-testid="supplier-last-name" formControlName="last_name"
                       [ngClass]="getFormGroupErrorClasses(contact.controls.last_name)"
                       placeholder="Last name">
                <div class="invalid-feedback" *ngIf="showErrorBlock(contact.controls.last_name)">
                    <p *ngIf="contact.controls.last_name.errors.required">Last name is a required field</p>
                </div>
                <small class="form-text text-muted"></small>
            </div>
            <div formGroupName="contact" class="form-group col-12 col-md-6" [ngClass]="getFormGroupErrorClasses(contact.controls.first_name)">
                <label>First Name</label>
                <input class="form-control" data-testid="supplier-first-name" formControlName="first_name"
                       [ngClass]="getFormGroupErrorClasses(contact.controls.first_name)"
                       placeholder="First name">
                <div class="invalid-feedback" *ngIf="showErrorBlock(contact.controls.first_name)">
                    <p *ngIf="contact.controls.first_name.errors.required">First name is a required field</p>
                </div>
                <small class="form-text text-muted"></small>
            </div>

            <div formGroupName="contact" class="form-group col-12 col-md-6">
                <label>Email</label>
                <input toLowercase type="email" class="form-control" data-testid="supplier-email" formControlName="email"
                       [ngClass]="getFormGroupErrorClasses(contact.controls.email)"
                       placeholder="Email">
                <div class="invalid-feedback" *ngIf="showErrorBlock(contact.controls.email)">
                    <span *ngIf="contact.controls.email.errors.required || contact.controls.email.errors.email">Email address is a required field</span>
                </div>
                <small class="form-text text-muted"></small>
            </div>
            <div formGroupName="contact"  class="form-group col-12 col-md-6" [ngClass]="getFormGroupErrorClasses(contact.controls.phone)">
                <label>Phone</label>
                <input [mask]="phoneMask" class="form-control" formControlName="phone"
                       [ngClass]="getFormGroupErrorClasses(contact.controls.phone)"
                       placeholder="Phone">
                <div class="invalid-feedback" *ngIf="showErrorBlock(contact.controls.phone)">
                    <p *ngIf="contact.controls.phone.errors.required">Phone number is a required field</p>
                </div>
                <small class="form-text text-muted"></small>
            </div>
            <div class="form-group col-12 col-md-6">
                <label>Tags</label>
                <ng-select
                      [items]="tags"
                      [addTag]="addTagPromise"
                      [loading]="loading"
                      multiple="true"
                      bindLabel="name"
                      (ngModelChange)="tagChange($event)"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="selectedTags">
                    <ng-template ng-tag-tmp let-search="searchTerm"><b>create new</b>: {{ search }} </ng-template>
                </ng-select>
            </div>
          </div>
    </form>
</div>
<div class="modal-footer">
    <button class="btn btn-light" (click)="close()">Close</button>
    <jft-submit-button
        data-testid="supplier-save"
        (onClick)="submitSupplier()"
        [class]="'btn btn-outline-primary'"
        [title]="'Save'"
        [disabled]="form.invalid"
        [loading]="form.disabled"
        [ngbPopover]="getFirstFormGroupErrorLabel(form, contact)" triggers="mouseenter:mouseleave" placement="left"
        [loadingTitle]="'Saving'" triggers="mouseenter:mouseleave" placement="right">
    </jft-submit-button>
</div>
